<template>
  <div class="coupon">
    <nav>
      <span :class="type == 1 ? 'active' : ''" @click="type = 1">{{
        $fanyi("我的券包")
      }}</span
      ><span :class="type == 2 ? 'active' : ''" @click="type = 2">{{
        $fanyi("使用记录")
      }}</span>
      <span class="flexBox"></span>
    </nav>

    <div class="main">
      <!-- 优惠券列表 -->
      <div class="couponList" v-if="type == 1">
        <div v-for="(item, index) in couponList" :key="index" class="item">
          <div class="item__top">
            <div class="coupon-badge">
              <span v-if="isCouponPast(item)" class="coupon-badge__text">{{
                $fanyi("已过期")
              }}</span>
              <span
                v-else-if="sameDate(item.free_datetime_end)"
                class="coupon-badge__text coupon-badge__text--warn"
                >{{ $fanyi("今日到期") }}</span
              >
              <span v-else-if="item.type != 30" class="coupon-badge__text">{{
                $fanyi("优惠券")
              }}</span>
              <span v-else class="coupon-badge__text">{{
                $fanyi("代金券")
              }}</span>
              <div class="coupon-badge__line"></div>
            </div>
            <div class="coupon-value">
              <template v-if="item.type == 30">{{ item.free_kin }}€</template>
              <span v-else class="coupon-value__title">{{ item.title }}</span>
            </div>
            <div class="coupon-limited">
              {{ $fanyi("订单金额") }} &gt; {{ item.restrictions }}
            </div>
            <div class="coupon-num">Nº.{{ item.number }}</div>
          </div>
          <div class="item__bottom">
            <div class="coupon-validity-label">{{ $fanyi("有效期") }}</div>
            <p class="coupon-validity-date">{{ item.free_datetime_start }}</p>
            <p class="coupon-validity-date">{{ item.free_datetime_end }}</p>
          </div>
        </div>
      </div>
      <!-- 使用列表 -->
      <div class="couponRecord" v-else>
        <div class="search">
          <el-select
            v-model="datas.type"
            class="uiSelect"
            :placeholder="$fanyi('请选择')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="input">
            <el-input
              class="uiInput"
              v-model="datas.keywords"
              :placeholder="$fanyi('请输入内容')"
              prefix-icon="el-icon-search"
              clearable
            ></el-input>
          </div>
          <el-button class="uiBtn uiGreen" @click="couponRecord">{{
            $fanyi("搜索")
          }}</el-button>
        </div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%" class="uiTable">
            <el-table-column
              prop="rowNumber"
              label="Nº"
              align="center"
              width="50"
            >
            </el-table-column>
            <el-table-column
              prop="number"
              :label="$fanyi('券编码')"
              align="center"
              width="170"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              :label="$fanyi('券类别')"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <div>
                  {{ $fanyi(scope.row.title) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="free_kin"
              :label="$fanyi('额度/可使用次数')"
              align="center"
              width="180px"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              :label="$fanyi('有效日期')"
              align="center"
              width="230px"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.free_datetime_start }}</p>

                <p>{{ scope.row.free_datetime_end }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="updatetime"
              :label="$fanyi('使用日期')"
              align="center"
              width="170px"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              :label="$fanyi('使用状态')"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == 10">
                  {{ $fanyi("待使用") }}
                </span>
                <span v-else-if="scope.row.status == 20">
                  {{ $fanyi("已使用") }}
                </span>
                <span v-else-if="scope.row.status == 30">
                  {{ $fanyi("已过期") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="order_sn"
              :label="$fanyi('订单号')"
              align="center"
              width="200"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="allpag">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="datas.page"
            :page-size="10"
            :page-sizes="[10, 20, 30, 50]"
            layout=" prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sameDate, pastDue } from "../../../../utlis/date";
export default {
  data() {
    return {
      type: 1,
      couponList: [],
      datas: {
        page: 1,
        pageSize: 10,
        keywords: "",
        type: "",
      },
      options: [
        {
          label: this.$fanyi("已使用"),
          value: "已使用",
        },
        {
          label: this.$fanyi("已过期"),
          value: "已过期",
        },
      ],
      value: "",
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.couponRecord();
    this.couponGet();
  },
  methods: {
    couponGet() {
      this.$api.couponGet({ page: 1, pageSize: 999 }).then((res) => {
        this.couponList = res.data.data;
        //console.log(this.couponList);
      });
    },
    couponRecord() {
      this.$api.couponRecord(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    handleCurrentChange(val) {
      this.datas.page = val;
      this.couponRecord();
    },
    sameDate(time) {
      //console.log(sameDate(time));
      return sameDate(time);
    },
    isCouponPast(item) {
      if (!item || !item.free_datetime_end) return false;
      return pastDue(item.free_datetime_end);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../css/mixin";
.coupon {
  background-color: #f8f7f7;
  .main {
    padding: 40px;
    background-color: #fff;
    min-height: 300px;
    border-radius: 0 0 12px 12px;
    border: 1px solid #eaecf0;
    border-top: none;
    .couponList {
      display: flex;
      flex-wrap: wrap;

      .item {
        box-sizing: border-box;
        width: 220px;
        height: 300px;
        margin: 0 16px 20px 0;
        /* 与券面绿一致，避免圆角/缩放时 1px 缝隙透出灰底形成顶横线 */
        background-image: url("~@/assets/user-img/index/coupon.svg");
        background-position: center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 0;
        overflow: hidden;
        border-radius: 14px;

        .item__top {
          height: 220px;
          min-height: 0;
          display: flex;
          flex-direction: column;
          padding: 20px 20px 26px;
          color: #ffffff;
        }

        .coupon-badge {
          align-self: flex-start;
          .coupon-badge__text {
            display: block;
            font-size: 18px;
            font-weight: normal;
            line-height: 24px;
          }
          .coupon-badge__text--warn {
            color: #ffe08a;
          }
          .coupon-badge__line {
            width: 20px;
            height: 2px;
            background: #ffffff;
            margin-top: 8px;
            border-radius: 1px;
          }
        }

        .coupon-value {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 36px;
          font-weight: 700;
          line-height: 1.1;
          padding: 20px 0;
          .coupon-value__title {
            font-size: 18px;
            font-weight: bold;
            line-height: 24px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .coupon-limited {
          text-align: center;
          font-size: 12px;
          font-weight: normal;
          line-height: 16px;
          margin-bottom: 20px;
        }

        .coupon-num {
          font-size: 12px;
          font-weight: normal;
          line-height: 16px;
          text-align: center;
        }

        .item__bottom {
          flex: 0 0 auto;
          min-height: 78px;
          box-sizing: border-box;
          padding: 8px 20px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #000;
        }

        .coupon-validity-label {
          font-size: 12px;
          font-weight: normal;
          line-height: 16px;
          margin-bottom: 4px;
        }

        .coupon-validity-date {
          margin: 0;
          font-size: 12px;
          font-weight: normal;
          line-height: 16px;
        }
      }
    }
  }
}
.couponRecord {
  .search {
    display: flex;
    gap: 12px;
    .uiSelect {
      width: 240px;
      height: 40px;
    }
    .input {
      display: inline-block;
      width: 400px;
      /deep/ .el-input__prefix .el-input__icon {
        font-size: 15px;
        color: #000000;
      }
    }
  }
  .table {
    margin-top: 20px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #eaecf0;
  }
  .allpag {
    margin-top: 30px;
    text-align: center;
  }
}
nav {
  display: flex;
  border: 1px solid #eaecf0;
  border-bottom: none;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
  overflow: hidden;

  > span {
    @extend .dip;
    width: max-content;
    flex-direction: column;
    height: 48px;
    padding: 0 13px;
    background: #f9f9f9;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #000000;
    line-height: 16px;
    cursor: pointer;
    position: relative;
    border-bottom: 1px solid #eaecf0;
    border-right: 1px solid #eaecf0;

    &.active {
      background-color: #ffffff;
      border-bottom: none;
    }
    &.active::after {
      background: #ffffff;
    }
    .label {
      line-height: 16px;
      white-space: nowrap;
      display: block;
    }
    span.wrapTitle {
      white-space: normal;
      line-height: 1.1;
    }

    .numberCount {
      width: 100%;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      text-align: left;
      color: #009246;
    }
  }
  .flexBox {
    flex: 1;
    background-color: #fff;
  }
  > span.allStatusSpan {
    flex: 0 0 60px;
  }
  .yellowIconBox {
    flex: 0 0 40px;
    background-color: #fff;
    border-bottom: 1px solid #eaecf0;
    .yellowIcon {
      @extend .dip;
      width: 50px;
      cursor: pointer;
      .yellowIconImg {
        width: 20px;
        height: 20px;
        display: block;
      }
    }
  }
}
</style>
